'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {UserPin} from './components/UserPin';
import {UserHomeController} from './controllers/UserHomeController';
import {UserPinDomainProvider} from './domain/UserPinDomain';
import {USER_PRIORITY} from './enums/USER_PRIORITIES';
import {injector as prioritiesListConfigInjector} from './redux/prioritiesListConfig';


const angular = require('angular');

module.exports = angular
  .module('app.priorities', [
    'domain',
  ])
  .constant('USER_PRIORITY', USER_PRIORITY)
  .run(runInjector(UserPin))
  .run(prioritiesListConfigInjector)

  .provider('UserPinDomain', UserPinDomainProvider)

  .controller('UserHomeController', UserHomeController)
;



// WEBPACK FOOTER //
// ./src/js/priorities/index.js